import UserIcon from "../common/UserIcon";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useAuth } from "@qure/qure-auth";
import { getUserName } from "../../utils";

interface UserBioProps {
  onLogout?: () => void;
}

const UserBio = (props: UserBioProps) => {
  const { onLogout } = props;
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const user = get(userInfo, ["details"], null);

  return (
    <div className="flex sm:hidden items-center justify-between p-4 border-b border-gray-800">
      <div className="flex items-center justify-start">
        <UserIcon name={getUserName(user)} className="h-8 w-8 text-lg" />
        <div className="flex flex-col items-start justify-center ml-3">
          <div className="font-medium text-base break-all">{getUserName(user)}</div>
          <div className="text-md text-gray-400 break-all">
            {get(user, ["email"], "")}
          </div>
          <div className="text-md text-gray-400 break-all">
            {get(user, ["phone"], "")}
          </div>
        </div>
      </div>
      <div className="flex whitespace-nowrap text-gray-500 text-md font-bold py-3">
        <button onClick={onLogout}>{t("logout_key")}</button>
      </div>
    </div>
  );
};

export default UserBio;
